/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import type { PreloadedQuery } from 'react-relay';
import {
	createRelayResource,
	RELAY_RESOURCE_TYPE,
} from '@jira/platform__graphql-relay-utils/src/services/resources/index.tsx';
import PreviewPanelRelayQuery, {
	type PreviewPanelQuery,
} from '@jira/issue__preview-panels/src/__generated__/PreviewPanelQuery.graphql.ts';
import type { RouteResource } from '@atlassian/react-resource-router';

export const previewPanelStateResource: RouteResource<
	PreloadedQuery<PreviewPanelQuery, Record<string, unknown>>
> = createRelayResource<PreviewPanelQuery>({
	type: `${RELAY_RESOURCE_TYPE}_PREVIEW_PANEL`,
	getQuery: (_, { tenantContext: { cloudId } }) => ({
		parameters: PreviewPanelRelayQuery,
		variables: { cloudId },
		options: { fetchPolicy: 'store-and-network' },
	}),
	isCritical: true,
	isBrowserOnly: false,
});
